export const getAlbumsStore = (state: any) => state.albums.allAlbums;

export const getPurchaseLinkStore = (state: any) => state.albums.purchaseLink;

